const numberOfPagesFromItems = (items, itemsPerPage) => {
  return Math.ceil(items / itemsPerPage);
};
const getPagesRange = (from, to) => Array.from(Array(to + 1 - from).keys()).map((i) => from + i);
const changePageIfAppropriate = (nextPage, totalItems, itemsPerPage, onPageChanged) => {
  const pageCount = numberOfPagesFromItems(totalItems, itemsPerPage);
  const nextPageExists = nextPage > 0 && nextPage <= pageCount;
  if (nextPageExists && typeof onPageChanged === "function") {
    onPageChanged(nextPage);
  }
};

export { changePageIfAppropriate, getPagesRange, numberOfPagesFromItems };
//# sourceMappingURL=helpers.es.js.map
